import './Footer.css';

function Footer() {
  return (
    <footer className="footer bg-dark text-white pt-4">
      <div className="container text-center">
        <img src="/img/CodeNest_Dev_Neg.png" alt="Code Nest Dev" className="footer-logo mb-3" />

        <p className="mb-2">Creamos soluciones digitales a tu medida.</p>
        
        <div className="footer-links mb-3">
          <a href="#nosotros">Nosotros</a>
          <a href="#servicios">Servicios</a>
          <a href="#proyecto">Proyectos</a>
          <a href="#contacto">Contacto</a>
        </div>

        <small>&copy; {new Date().getFullYear()} Code Nest Dev. Todos los derechos reservados.</small>
      </div>
    </footer>
  );
}

export default Footer;
